<template>
  <v-dialog max-width="600px" v-model="dialog">
    <v-card>
      <!-- フォームのタイトル -->
      <v-card-title class="py-5">
        <h2>{{ formTitle }}</h2>
      </v-card-title>

      <!-- フォームの内容 -->
      <v-card-text>
        <v-form class="px-3" ref="form">
          <!-- 氏名 -->
          <v-text-field
            v-if="!mode"
            v-model="name"
            prepend-icon="mdi-account"
            :rules="[rules.required, rules.max]"
            counter
            maxlength="30"
            label="氏名"
          ></v-text-field>

          <!-- メールアドレス  -->
          <v-text-field
            v-model="email"
            prepend-icon="mdi-email"
            :rules="[rules.required, rules.emailLength, rules.email]"
            label="メールアドレス"
          ></v-text-field>

          <!-- パスワード -->
          <v-text-field
            v-model="password"
            prepend-icon="mdi-lock"
            :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.password]"
            :type="showpassword ? 'text' : 'password'"
            label="パスワード"
            counter
            :value="password"
            @click:append="showpassword = !showpassword"
            @keypress.prevent.enter.exact="enable_submit"
            @keyup.prevent.enter.exact="submit"
          ></v-text-field>
        </v-form>
        <div>
          {{ errorMessage }}
        </div>
      </v-card-text>

      <!-- フォームのアクションボタン -->
      <v-card-actions class="pa-5 pt-0">
        <v-row no-gutters>
          <v-col cols="12" sm="8">
            <!-- モード切り替えボタン -->
            <v-btn color="primary" text @click="changeMode">{{
              modeButtonText
            }}</v-btn>
            <v-btn v-if="mode" color="primary" text @click="forgetPassword"
              >パスワードを忘れた</v-btn
            >
          </v-col>
          <v-col cols="12" sm="4" class="text-end">
            <!-- 実行ボタン -->
            <v-btn
              color="primary"
              rounded
              class="px-5"
              :loading="loading"
              @click="
                enable_submit();
                submit();
              "
              >{{ submitButtonText }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LoginDialog',
  props: {
    // addNewOnly: Boolean,
    // groupId: Number,
    loginAction: Function,
    registerUserAction: Function,
  },
  data: () => ({
    dialog: false,
    mode: true,
    name: '',
    email: '',
    password: '',
    showpassword: false,
    loading: false,
    rules: {
      required: value => !!value || '必須入力です',
      max: v => v.length <= 30 || '30文字以内で入力してください',
      emailLength: v => v.length <= 100 || '100文字以内で入力してください',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || '無効なメールアドレスです';
      },
      password: value => {
        const pattern = /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{6,100}$/i;
        return (
          pattern.test(value) ||
          '半角英数字をそれぞれ1種類以上含んだ6文字以上で入力してください'
        );
      },
    },
    errorMessage: null,
    can_submit_search: false,
  }),
  computed: {
    // loginMode() {
    //   return this.addNewOnly ? false : this.mode
    // },
    formTitle() {
      return this.mode ? 'ログイン' : 'アカウント作成';
    },
    submitButtonText() {
      return this.mode ? 'ログイン' : '登録する';
    },
    modeButtonText() {
      return this.mode ? 'ユーザー登録' : '既にアカウントを持っている';
    },
    action() {
      return function() {
        return this.mode
          ? this.loginAction({
              email: this.email,
              password: this.password,
            })
          : this.registerUserAction({
              name: this.name,
              email: this.email,
              password: this.password,
              customer_group_id: 0,
              authority: 0,
            });
      };
    },
  },
  methods: {
    // ダイアログオープン（親コンポーネントから$refs経由で使用する）
    open() {
      this.dialog = true;
      this.mode = true;
    },
    // フォーム初期化
    clear() {
      this.name = '';
      this.email = '';
      this.password = '';
      this.errorMessage = null;
      this.$refs.form.resetValidation();
    },
    // ログインモード（ログイン or アカウント登録）変更
    changeMode() {
      this.mode = !this.mode;
      this.clear();
    },
    // パスワード忘れたクリック
    forgetPassword() {
      this.dialog = false;
      this.$emit('forget-password-click');
    },
    enable_submit() {
      this.can_submit_search = true;
    },
    // ログイン or アカウント登録してログイン
    submit() {
      if (!this.can_submit_search) return;
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.action()
          .then(() => {
            this.dialog = false;
          })
          .catch(e => {
            this.errorMessage = e.message;
          })
          .finally(() => {
            this.loading = false;
            this.can_submit_search = false;
          });
      }
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.clear();
      }
    },
  },
};
</script>
